import React from 'react'

class Copyright extends React.Component {
    render() {
        return (
            <div>
                <p className="attribution">&copy;{this.props.copyholder}</p>
            </div>
        )
    }
}

export default Copyright